// extracted by mini-css-extract-plugin
export default {"root":"PlanRows-root_sTJ9I"};